export default "__VITE_PUBLIC_ASSET__be38e94d__"